<template>
  <button class="flex items-center justify-start py-2.5" type="button">
    <p v-if="text && suffix" class="flex w-full items-center space-x-1">
      <span
        class="text-text-neutral-primary inline-block truncate"
        data-qa-id="searchFormInput.text"
        >{{ text }}</span
      >
      <span
        class="text-text-neutral-quaternary whitespace-nowrap"
        data-qa-id="searchFormInput.suffix"
        >{{ suffix }}</span
      >
    </p>
    <p
      v-else-if="placeholder"
      :class="
        hasError ? 'text-text-negative-primary' : 'text-text-neutral-quaternary'
      "
    >
      {{ placeholder }}
    </p>
  </button>
</template>

<script setup lang="ts">
  defineProps<{
    text?: string;
    suffix?: string;
    placeholder?: string;
    hasError?: boolean;
  }>();
</script>
